import i18n from '@/i18n';

export const ICON_MAP = {
  'tachometer-alt': 'gaikuang',
  'shopping-bag': 'shangpin',
  'clipboard-list': 'jiaoyi',
  'store-alt': 'jingxiaoshang',
  'gem1': 'huiyuan',
  'brush': 'moban',
  'gift': 'yingxiao',
  'file-invoice-dollar': 'caiwu',
  'chart-bar': 'tongji',
  'sitemap': 'zhandian',
  'yingyong-01': 'yingyong',
  'cog': 'shezhi'
}
export const SALES_STATUS = [
  { title: i18n.t('consts.index.316637-0'), value: 'onsale' },
  { title: i18n.t('consts.index.316637-1'), value: 'offline_sale' },
  { title: i18n.t('consts.index.316637-2'), value: 'only_show' },
  { title: i18n.t('consts.index.316637-3'), value: 'instock' }
]

export const DISTRIBUTION_TYPE = [
  { title: i18n.t('consts.index.316637-4'), value: '' },
  { title: i18n.t('consts.index.316637-5'), value: 'logistics' },
  { title: i18n.t('consts.index.316637-6'), value: 'dada' },
  { title: i18n.t('consts.index.316637-7'), value: 'ziti' }
]

export const ORDER_STATUS = [
  { title: i18n.t('consts.index.316637-4'), value: '' },
  { title: i18n.t('consts.index.316637-8'), value: 'notpay' },
  { title: i18n.t('consts.index.316637-9'), value: 'notship' },
  { title: i18n.t('consts.index.316637-10'), value: 'shipping' },
  { title: i18n.t('consts.index.316637-11'), value: 'cancelapply' },
  { title: i18n.t('consts.index.316637-12'), value: 'ziti' },
  { title: i18n.t('consts.index.316637-13'), value: 'cancel' },
  { title: i18n.t('consts.index.316637-14'), value: 'finish' },
  { title: i18n.t('consts.index.316637-15'), value: 'dada_0' },
  { title: i18n.t('consts.index.316637-16'), value: 'dada_1' },
  { title: i18n.t('consts.index.316637-17'), value: 'dada_2' },
  { title: i18n.t('consts.index.316637-18'), value: 'dada_100' },
  { title: i18n.t('consts.index.316637-19'), value: 'dada_3' },
  { title: i18n.t('consts.index.316637-20'), value: 'dada_9' }
]

export const ORDER_B2C_STATUS = [
  { title: i18n.t('consts.index.316637-4'), value: '' },
  { title: i18n.t('consts.index.316637-8'), value: 'notpay' },
  { title: i18n.t('consts.index.316637-9'), value: 'notship' },
  { title: i18n.t('consts.index.316637-10'), value: 'shipping' },
  { title: i18n.t('consts.index.316637-11'), value: 'cancelapply' },
  { title: i18n.t('consts.index.316637-12'), value: 'ziti' },
  { title: i18n.t('consts.index.316637-13'), value: 'cancel' },
  { title: i18n.t('consts.index.316637-14'), value: 'finish' }
]

export const IN_PURCHASE_STATUS = [
  { title: i18n.t('consts.index.316637-4'), value: '' },
  { title: i18n.t('consts.index.316637-8'), value: 'notpay' },
  { title: i18n.t('consts.index.316637-9'), value: 'notship' },
  { title: i18n.t('consts.index.316637-10'), value: 'shipping' },
  { title: i18n.t('consts.index.316637-11'), value: 'cancelapply' },
  { title: i18n.t('consts.index.316637-13'), value: 'cancel' },
  { title: i18n.t('consts.index.316637-14'), value: 'finish' }
  // { title: i18n.t('consts.index.316637-19'), value: 'dada_3' }
]

export const ORDER_TYPE = [
  { title: i18n.t('consts.index.316637-4'), value: '' },
  { title: i18n.t('consts.index.316637-21'), value: 'groups' },
  { title: i18n.t('consts.index.316637-22'), value: 'seckill' },
  { title: i18n.t('consts.index.316637-23'), value: 'normal' },
  { title: i18n.t('consts.index.316637-24'), value: 'community' }
  // { title: "导购订单", value: "shopguide" },
  // { title: "跨境订单", value: "crossborder" },
  // { title: "助力订单", value: "bargain" },
  // { title: "服务类订单", value: "services" },
  // { title: i18n.t('consts.index.316637-25'), value: "excard"}
]

export const ORDER_TYPE_STANDARD = [
  { title: i18n.t('consts.index.316637-4'), value: '' },
  { title: i18n.t('consts.index.316637-21'), value: 'groups' },
  { title: i18n.t('consts.index.316637-22'), value: 'seckill' },
  { title: i18n.t('consts.index.316637-23'), value: 'normal' },
  { title: i18n.t('consts.index.316637-24'), value: 'community' },
  { title: i18n.t('consts.index.316637-25'), value: 'excard' },
  { title: i18n.t('consts.index.316637-26'), value: 'shopadmin' }
]

export const INVOICE_STATUS = [
  { title: i18n.t('consts.index.316637-4'), value: '' },
  { title: i18n.t('consts.index.316637-27'), value: 0 },
  { title: i18n.t('consts.index.316637-28'), value: 1 }
]

export const ORDER_CATEGORY = [
  { title: i18n.t('consts.index.316637-4'), value: '' },
  { title: i18n.t('consts.index.316637-29'), value: 'self' },
  { title: i18n.t('consts.index.316637-30'), value: 'shop' }
]

export const REFUND_STATUS = {
  READY: i18n.t('consts.index.316637-31'),
  AUDIT_SUCCESS: i18n.t('consts.index.316637-32'),
  SUCCESS: i18n.t('consts.index.316637-33'),
  SHOP_CHECK_FAILS: i18n.t('consts.index.316637-34'),
  CANCEL: i18n.t('consts.index.316637-35'),
  PROCESSING: i18n.t('consts.index.316637-36'),
  FAILS: i18n.t('consts.index.316637-37'),
  WAIT_CHECK: i18n.t('consts.index.316637-31'),
  WAIT_REFUND: i18n.t('consts.index.316637-38')
}

export const REFUND_PROCESS = {
  0: i18n.t('consts.index.316637-39'),
  1: i18n.t('consts.index.316637-13'),
  2: i18n.t('consts.index.316637-40'),
  3: i18n.t('consts.index.316637-14'),
  4: i18n.t('consts.index.316637-41')
}

export const PROFIT_TYPE = {
  1: i18n.t('consts.index.316637-42'),
  2: i18n.t('consts.index.316637-43'),
  3: i18n.t('consts.index.316637-44')
}

export const PAY_TYPE = {
  wxpay: i18n.t('consts.index.316637-45'),
  amorepay: i18n.t('consts.index.316637-45'),
  wechat: i18n.t('consts.index.316637-45'),
  wepayjs: i18n.t('consts.index.316637-45'),
  wxpaypc: i18n.t('consts.index.316637-46'),
  wxpayh5: i18n.t('consts.index.316637-47'),
  alipay: i18n.t('consts.index.316637-48'),
  alipayh5: i18n.t('consts.index.316637-49'),
  deposit: i18n.t('consts.index.316637-50'),
  point: i18n.t('consts.index.316637-51'),
  // pos: 'POS银行卡支付',
  pos: i18n.t('consts.index.316637-52'),
  wxpaypos: i18n.t('consts.index.316637-53'),
  alipaypos: i18n.t('consts.index.316637-54'),
  chinaums: i18n.t('consts.index.316637-55'),
  // pay_channel
  wx_lite: i18n.t('consts.index.316637-45'),
  wx_pub: i18n.t('consts.index.316637-47'),
  wx_qr: i18n.t('consts.index.316637-46'),
  alipay_wap: i18n.t('consts.index.316637-49'),
  alipay_qr: i18n.t('consts.index.316637-56'),
  alipaymini: i18n.t('consts.index.316637-57')
}

export const PAY_STATUS = {
  SUCCESS: i18n.t('consts.index.316637-58'),
  REFUND: i18n.t('consts.index.316637-59'),
  CANCEL_CLOSED: i18n.t('consts.index.316637-13'),
  REFUND_SUCCESS: i18n.t('consts.index.316637-33'),
  NOTPAY: i18n.t('consts.index.316637-60'),
  CLOSED: i18n.t('consts.index.316637-61'),
  REVOKED: i18n.t('consts.index.316637-62'),
  PAYERROR: '支付失败(其他原因，如银行返回失败)'
}

export const PICKER_DATE_OPTIONS = {
  shortcuts: [
    {
      text: i18n.t('consts.index.316637-65'),
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('consts.index.316637-66'),
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('consts.index.316637-67'),
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
        picker.$emit('pick', [start, end])
      }
    }
  ]
}

export const FORM_COMP = {
  INPUT: 1,
  NUMBER: 2,
  DATE: 3,
  RADIO: 4,
  CHECKBOX: 5,
  MOBILE: 6,
  IMAGE: 7
}

export const SYSTEM_CONFIG = {
  platform: { name: 'Powered By ShopeX', theme: '#CB060F' },
  standard: { name: i18n.t('consts.index.316637-68'), theme: '#FF9D00' },
  b2c: { name: i18n.t('consts.index.316637-69'), theme: '#157FE3' },
  in_purchase: { name: i18n.t('consts.index.316637-70'), theme: '#EC442E' }
}

export const LINK_PATH = {
  'goods': i18n.t('consts.index.316637-71'),
  'store': i18n.t('consts.index.316637-72'),
  'sale_category': i18n.t('consts.index.316637-73'),
  'category': i18n.t('consts.index.316637-74'),
  'tag': i18n.t('consts.index.316637-75'),
  'article': i18n.t('consts.index.316637-76'),
  'planting': i18n.t('consts.index.316637-77'),
  'link': i18n.t('consts.index.316637-78'),
  'marketing': i18n.t('consts.index.316637-79'),
  'regactivity': i18n.t('consts.index.316637-80'),
  'seckill': i18n.t('consts.index.316637-81'),
  'custom_page': i18n.t('consts.index.316637-82'),
  'liverooms': i18n.t('consts.index.316637-83'),
  'other_wxapp': i18n.t('consts.index.316637-84')
}

export const CARD_TYPE = {
  'discount': i18n.t('consts.index.316637-85'),
  'cash': i18n.t('consts.index.316637-86'),
  'new_gift': i18n.t('consts.index.316637-87')
}

export const SECKILL_ACTIVITY_STATUS = {
  'waiting': i18n.t('consts.index.316637-88'),
  'in_the_notice': i18n.t('consts.index.316637-89'),
  'in_sale': i18n.t('consts.index.316637-90'),
  'it_has_ended': i18n.t('consts.index.316637-91')
}
